import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { getSellerDetails } from '@/data/api/request/sellerRequests';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useGetSellerDetails(sellerId?: string) {
  const { showSnackError } = useSnackbarContext();

  const { data, error } = useQuery({
    queryFn: () => getSellerDetails({ sellerId: sellerId ?? '' }),
    queryKey: [cacheKeys.seller.details, sellerId],
    enabled: !!sellerId,
  });

  useEffect(() => {
    if (error)
      showSnackError('Error, no se pudo obtener los detalles del vendedor');
  }, [error]);

  return { data };
}
